module.exports = __webpack_public_path__ + "img/ZNZBZZYJC_7.7e0e09a4.jpg";